import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import lang from '../../lib/language';

import MaxDrawdownIcon from '../../assets/img/MaxDrawdown.png';
import { useIsMobile } from '../../hooks';
import BaseModal from '../../shared_components/BaseModal/BaseModal';
import Button from '../../shared_components/Button/Button';
import { ButtonTypesEnum } from '../../shared_components/Button/Button.types';
import {
  RESET_DAILY_LOSS_CONFIRM_MODAL_KEY,
  resetLocalStorageItem,
  REWIND_MODAL_KEY,
} from '../../util/localStorageHelpers';
import { UI_ROUTES } from '../../util/routes';
import { MobileDrawer } from '../index';

import styles from './MaxDrawdownReachedModal.module.scss';

type Props = {
  toggleModal: () => void;
  isOpen: boolean;
};

const MaxDrawdownReachedModal = ({ isOpen, toggleModal }: Props) => {
  const { isMobile } = useIsMobile();
  const navigate = useNavigate();

  const chooseAPlan = () => {
    toggleModal();
    navigate(UI_ROUTES.products);
  };

  useEffect(() => {
    if (isOpen) {
      // Clear localStorage to reset all modals preferences (e.g., RewindTradingDayModal)
      resetLocalStorageItem(REWIND_MODAL_KEY, 'MaxDrawdownReachedModal');
      resetLocalStorageItem(RESET_DAILY_LOSS_CONFIRM_MODAL_KEY, 'MaxDrawdownReachedModal');
    }
  }, [isOpen]);

  const renderContent = () => (
    <>
      <div className={styles.iconHolder}>
        <img src={MaxDrawdownIcon} alt="Warning icon" />
      </div>
      <div className={styles.textWrapper}>
        <div className={styles.title}>{lang.maxDrawdownReached()}</div>
        <div className={styles.text}>
          <p>{lang.tryAgainAndSelectNewPlan()}</p>
        </div>
      </div>
      <div className={styles.buttonsWrapper}>
        <Button
          biggerFontSize
          fullWidth
          variant={ButtonTypesEnum.Primary}
          onClick={() => chooseAPlan()}
        >
          {lang.choosePlanAndTryAgain()}
        </Button>
        <Button
          biggerFontSize
          fullWidth
          variant={ButtonTypesEnum.Secondary}
          onClick={() => toggleModal()}
        >
          {lang.commonNotNow()}
        </Button>
      </div>
    </>
  );

  return (
    <>
      {isMobile ? (
        <MobileDrawer isOpen={isOpen} title="" onClose={toggleModal}>
          {renderContent()}
        </MobileDrawer>
      ) : (
        <BaseModal isOpen={isOpen}>
          {renderContent()}
        </BaseModal>
      )}
    </>
  );
};

export default MaxDrawdownReachedModal;
